const videoMergeProps = (stateProps, dispatchProps, ownProps) => ({
    ...ownProps,
    ...stateProps,
    ...dispatchProps,
    updateLiveBar() {
        const {
            liveNow: { liveChannelId },
        } = stateProps;
        dispatchProps.updateLiveBarByChannelId(liveChannelId);
    },
});

export default videoMergeProps;
